(function() {
    'use strict';

    angular
        .module('womenCellApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
